var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',{staticClass:"headline text-uppercase"},[_c('span',[_vm._v("時間計算")])])],1),_c('v-content',[_c('HelloWorld')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }